import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/assets";

const nav = [
  { to: "/", label: "Home" },
  { to: "/about", label: "Meet Judge Auntie™" },
  { to: "/five-things", label: "Five Takeaways" },
  { to: "/book", label: "Book Judge Auntie™" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 bg-cream/85 backdrop-blur-xl border-b border-gold-light">
      {/* Top row — logo left (desktop) / centered (mobile), auth right */}
      <div className="brand-container relative flex items-center justify-between py-2 min-h-[11rem]">
        <div className="flex items-center lg:flex-1">
          <button className="lg:hidden text-plum mr-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {open ? <X /> : <Menu />}
          </button>
          <Link to="/" className="hidden lg:flex items-center" data-testid="site-logo-link">
            <img src={LOGO_URL} alt="Judge Auntie Says" style={{ height: "10rem" }} className="w-auto object-contain" />
          </Link>
        </div>

        <Link to="/" className="lg:hidden absolute left-1/2 -translate-x-1/2 flex items-center justify-center" data-testid="site-logo-link-mobile">
          <img src={LOGO_URL} alt="Judge Auntie Says" style={{ height: "10rem" }} className="w-auto object-contain" />
        </Link>

        <div className="flex items-center justify-end gap-3 whitespace-nowrap">
          {user && user.role ? (
            <>
              {(user.role === "admin" || user.role === "content_manager") && (
                <Link to="/admin" className="hidden lg:inline text-sm font-medium text-charcoal/80 hover:text-plum" data-testid="header-admin-link">Admin</Link>
              )}
              <Link to="/member" className="btn-primary !py-2 !px-4 text-xs" data-testid="header-member-link">
                <User className="w-3.5 h-3.5" /> <span className="hidden sm:inline">My Chambers</span>
              </Link>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

      {/* Nav row — centered underneath the logo */}
      <nav className="hidden lg:flex items-center justify-center gap-8 pb-3 border-t border-gold-light/50 pt-2">
        {nav.map((n) => (
          <NavLink key={n.to} to={n.to}
            data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
            className={({isActive}) =>
              `text-sm font-medium tracking-wide transition-colors ${isActive ? "text-plum" : "text-charcoal/70 hover:text-plum"}`}>
            {n.label}
          </NavLink>
        ))}
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-cream border-t border-gold-light">
          <div className="brand-container py-6 flex flex-col gap-4">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
                className={({isActive}) => `text-base font-medium ${isActive ? "text-plum" : "text-charcoal/80"}`}
                data-testid={`mnav-${n.to.replace(/\//g, "") || "home"}`}>
                {n.label}
              </NavLink>
            ))}
            <div className="h-px bg-gold-light my-2" />
            {user && user.role ? (
              <>
                {(user.role === "admin" || user.role === "content_manager") && (
                  <Link to="/admin" onClick={() => setOpen(false)} className="btn-outline">Admin</Link>
                )}
                <Link to="/member" onClick={() => setOpen(false)} className="btn-primary">My Chambers</Link>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
